export const SET_LOADING = 'src/store/auth/SET_LOADING'
export const SET_CHANGE_PASSWORD = 'src/store/auth/SET_CHANGE_PASSWORD'
export const SET_FORGOT_PASSWORD = 'src/store/auth/SET_FORGOT_PASSWORD'
export const SET_LOGIN_OTP = 'src/store/auth/SET_LOGIN_OTP'
export const SET_LOGIN_PASSWORD = 'src/store/auth/SET_LOGIN_PASSWORD'
export const SET_LOGOUT = 'src/store/auth/SET_LOGOUT'
export const SET_REFRESH_TOKEN = 'src/store/auth/SET_REFRESH_TOKEN'
export const SET_VERIFY_ACCOUNT = 'src/store/auth/SET_VERIFY_ACCOUNT'
